<h1 class="flex items-center  cursor-pointer" [ngClass]="{'justify-end': !logoWhite}">
  <img *ngIf="!logoWhite" [routerLink]="isLogged ? ['/login'] : ['/']" src="/frontend-assets/logos/newlogo-451x362.webp" class="w-16 h-auto" alt="Awread Logo"
    width="451" height="362" />
  <a *ngIf="logoWhite" aria-label="logo-icon" class="inline-block" [routerLink]="['/']">
    <!-- <fa-icon class="pl-2 pb-2 text-4xl text-white" [icon]="iconAwread"></fa-icon> -->
    <fa-icon class="text-xl md:text-3xl text-white" [icon]="iconAwread"></fa-icon>
  </a>
</h1>